import classNames from 'classnames';

import { ClassNameType } from 'interfaces';
import { CalculatorStepState } from 'enums/calculator';

const styles = {
  component: (className: ClassNameType, state = CalculatorStepState.INACTIVE) => (classNames(
    'flex',
    'items-center',
    'w-full',
    className,
    {
      'text-darkGray': state === CalculatorStepState.INACTIVE,
      'font-bold text-tertiaryBlue': state === CalculatorStepState.ACTIVE,
      'text-tertiaryBlue': state === CalculatorStepState.COMPLETED,
      'pointer-events-none': state !== CalculatorStepState.COMPLETED,
    },
  )),
  circle: (state = CalculatorStepState.INACTIVE) => (classNames(
    'flex-none',
    'flex',
    'w-6',
    'h-6',
    'justify-center',
    'items-center',
    'rounded-full',
    'border',
    '!mr-0 md:!mr-6',
    'transition-all',
    {
      'text-transparent border-darkGray': state === CalculatorStepState.INACTIVE,
      'text-transparent border-tertiaryBlue': state === CalculatorStepState.ACTIVE,
      'text-white border-tertiaryBlue bg-tertiaryBlue': state === CalculatorStepState.COMPLETED,
    },
  )),
  text: (classNames(
    'hidden lg:inline-block',
  )),
  arrow: (classNames(
    'text-darkGray',
    'mx-auto',
  )),
};

export default styles;
